export default {
  path: '/my-follow',
  meta: {
    title: '我的关注',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my-follow`),
}



// WEBPACK FOOTER //
// ./src/views/MyFollow2/router.js